import React from 'react';

const PhoneChatIcon = ({ stroke = "#00FFFF", className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className,
    style: { ...style, overflow: "visible" }
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.9974 21.3333V26.6667C19.9974 27.0203 19.8569 27.3594 19.6069 27.6095C19.3568 27.8595 19.0177 28 18.6641 28H7.9974C7.64377 28 7.30464 27.8595 7.05459 27.6095C6.80454 27.3594 6.66406 27.0203 6.66406 26.6667V8C6.66406 7.64638 6.80454 7.30724 7.05459 7.05719C7.30464 6.80714 7.64377 6.66667 7.9974 6.66667H10.6641M13.3307 24V24.0133M14.6641 4H27.9974V14.6667H23.9974L18.6641 17.3333V14.6667H14.6641V4Z",
      stroke,
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
PhoneChatIcon.displayName = "Icons.PhoneChatIcon";

export { PhoneChatIcon };
//# sourceMappingURL=PhoneChatIcon.js.map
